<template>
  <div>
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <div class="flex justify-between items-center spacer-t-6 spacer-b-2">
          <h1 style="margin: 0;"><slot name="heading"/></h1>
          <button
            v-if="allowCreate"
            class="btn btn-primary btn-sm"
            @click="() => {
            this.$emit('showModal', null)
            }">
            Add <i class="fa fa-plus"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <table class="table table-hover table-tags table-data table-database-management">
        <thead>
        <tr>
          <th v-for="heading in headings" :key="heading.key">
            <button class="th-button" @click="() => { $emit('updateSort', heading.key) }">
              {{ heading.label}}
              <template v-if="sort === heading.key">
                <i v-if="sortDir === 'asc'" class="fa fa-arrow-up"></i>
                <i v-if="sortDir === 'desc'" class="fa fa-arrow-down"></i>
              </template>
            </button>
          </th>
          <th>Edit</th>
          <th v-if="showDelete">Delete</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="4" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin fa-2x fa-fw text-muted"></i>
            <span class="sr-only">Loading...</span>
          </td>
        </tr>
        <tr v-else-if="entries && entries.length === '0'">
          <td colspan="4" class="text-center">
            There are no entries that match your search
          </td>
        </tr>
        <slot v-else name="list"/>
        </tbody>
      </table>
    </div>
    <slot name="modal"/>
    <slot name="departmentsModal"/>
  </div>
</template>

<script>
import OpportunityManagementListItem from '../OpportunityManagementListItem'
import OpportunityManagementModal from '../OpportunityManagementModal'

export default {
  components: {OpportunityManagementModal, OpportunityManagementListItem},
  props: {
    headings: {
      required: true
    },
    entries: {
      required: true
    },
    loading: {
      required: true
    },
    sort: {
      required: true
    },
    sortDir: {
      required: true
    },
    allowCreate: {
      type: Boolean,
      default: true
    },
    showDelete: {
      default: false
    }
  }
}
</script>

<style lang="scss">
.table-database-management {
  .th-button {
    border: none;
    background: none;
    &:hover {
      text-decoration: underline;
    }
  }
  td:first-child {
    color: black;
  }
  td {
    color: #636363;
  }
  .edit-button, .delete-button {
    border: none;
    background: none;
    color: var(--brand-primary);
  }
}
#database-management-modal {
  .selectize-input {
    border: 2px solid black !important;
  }
}
</style>
